import {
  FormControl,
  Input,
  InputGroup,
  Text,
  useToast,
  Button,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Checkbox,
} from "@chakra-ui/react";
import { Link, useNavigate } from "react-router-dom";
import { Container, Menu } from "./styles";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { api } from "../../Api/ApiService";
import { AxiosError } from "axios";
import logo_branca from "../../assets/logo_branca_nina.png";
import { ModalInforComp } from "../../components/ModalInforcomplementares";
import { TextAlignRight } from "@phosphor-icons/react";
import InputMask from "react-input-mask";
import dayjs from "dayjs";

interface IInputsCadastroUser {
  nome: string;
  rg_cnh: string;
  cpf: string;
  rua: string;
  numero: number;
  bairro: string;
  cidade: string;
  uf: string;
  whatsapp: string;
  instagram: string;
  email: string;
  senha: string;
  termo: string;
}

const CadastroUser = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IInputsCadastroUser>();

  const toast = useToast();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = useRef(null);
  const [tutorId, setTutorId] = useState("");
  const [isModal, setIsmodal] = useState(false);

  async function onSubmit(data: IInputsCadastroUser) {
    try {
      if (password.length < 6) {
        toast({
          title: "Atenção",
          description: "A senha precisa ter no mínimo 6 caracteres",
          status: "warning",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
      } else {
        if (password === confirmPassword) {
          const result = await api.post(
            `/tutores?token=${process.env.REACT_APP_TOKEN_API}`,
            {
              nome: data.nome,
              rg_cnh: data.rg_cnh,
              cpf_tutor: data.cpf,
              rua: data.rua,
              numero: data.numero,
              bairro: data.bairro,
              cidade: data.cidade,
              uf: data.uf,
              whatsapp: data.whatsapp,
              instagram: data.instagram,
              email: data.email,
              senha: password,
            }
          );
          if (result.status === 201) {
            setTutorId(result.data.data.tutor_id);
            handleOpenModal();
            toast({
              title: "Cadastro realizado",
              description: result.data.message,
              status: "success",
              duration: 3000,
              position: "top",
              isClosable: true,
            });
          }
        } else {
          console.log("Senha invalida");
          toast({
            title: "Atenção",
            description: "As senhas não não iguais, tente novamente",
            status: "warning",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
        }
      }
    } catch (error: AxiosError | any) {
      toast({
        title: "Erro",
        description: error.response.data,
        status: "error",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
    }
  }

  const handleOpenModal = () => {
    setIsmodal(true);
  };

  const handleCloseModal = () => {
    setIsmodal(false);
  };

  return (
    <>
      <Menu>
        <div className="imag">
          <img src={logo_branca} />
        </div>
      </Menu>
      <Container>
        <div className="form">
          <div className="title">
            <h1>PREENCHA SUAS INFORMAÇÕES</h1>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <InputGroup className="iputGrup">
              <FormControl className="inputControl" mb={3}>
                <Text color="#3F3D56" fontSize={15} fontWeight={500}>
                  Nome
                </Text>
                <Input
                  type="text"
                  size={"sm"}
                  variant={"filled"}
                  border={"1px solid #B0BEC5"}
                  isInvalid={errors.nome ? true : false}
                  {...register("nome", {
                    required: "Campo obrigatório!",
                  })}
                />
                {errors.nome && (
                  <span className="label">{errors.nome.message}</span>
                )}
              </FormControl>
            </InputGroup>

            <InputGroup className="iputGrup">
              <FormControl className="inputControl" mr={7}>
                <Text color="#3F3D56" fontSize={15} fontWeight={500}>
                  CPF
                </Text>
                <Input
                  as={InputMask}
                  mask="999.999.999-99"
                  className="input-mb"
                  size={"sm"}
                  variant={"filled"}
                  border={"1px solid #B0BEC5"}
                  //isInvalid={errors.cpf ? true : false}
                  {...register("cpf", {
                    required: "Campo obrigatório!",
                  })}
                />
                {errors.cpf && (
                  <span className="label">{errors.cpf.message}</span>
                )}
              </FormControl>
              <FormControl className="inputControl">
                <Text color="#3F3D56" fontSize={15} fontWeight={500}>
                  RG/CNH
                </Text>
                <Input
                  type="number"
                  size={"sm"}
                  variant={"filled"}
                  border={"1px solid #B0BEC5"}
                  isInvalid={errors.rg_cnh ? true : false}
                  {...register("rg_cnh", {
                    required: "Campo obrigatório!",
                  })}
                />
                {errors.rg_cnh && (
                  <span className="label">{errors.rg_cnh.message}</span>
                )}
              </FormControl>
            </InputGroup>

            <InputGroup className="iputGrup">
              <FormControl className="inputControl" mr={7}>
                <Text color="#3F3D56" fontSize={15} fontWeight={500}>
                  Rua
                </Text>
                <Input
                  type="text"
                  className="input-mb"
                  size={"sm"}
                  variant={"filled"}
                  border={"1px solid #B0BEC5"}
                  isInvalid={errors.rua ? true : false}
                  {...register("rua", {
                    required: "Campo obrigatório!",
                  })}
                />
                {errors.rua && (
                  <span className="label">{errors.rua.message}</span>
                )}
              </FormControl>
              <FormControl className="inputControl">
                <Text color="#3F3D56" fontSize={15} fontWeight={500}>
                  Número
                </Text>
                <Input
                  type="number"
                  size={"sm"}
                  variant={"filled"}
                  border={"1px solid #B0BEC5"}
                  isInvalid={errors.numero ? true : false}
                  {...register("numero", {
                    required: "Campo obrigatório!",
                  })}
                />
                {errors.numero && (
                  <span className="label">{errors.numero.message}</span>
                )}
              </FormControl>
            </InputGroup>

            <InputGroup className="iputGrup">
              <FormControl className="inputControl" mr={7}>
                <Text color="#3F3D56" fontSize={15} fontWeight={500}>
                  Bairro
                </Text>
                <Input
                  type="text"
                  className="input-mb"
                  size={"sm"}
                  variant={"filled"}
                  border={"1px solid #B0BEC5"}
                  isInvalid={errors.bairro ? true : false}
                  {...register("bairro", {
                    required: "Campo obrigatório!",
                  })}
                />
                {errors.bairro && (
                  <span className="label">{errors.bairro.message}</span>
                )}
              </FormControl>
              <FormControl className="inputControl" mr={7}>
                <Text color="#3F3D56" fontSize={15} fontWeight={500}>
                  Cidade
                </Text>
                <Input
                  type="text"
                  className="input-mb"
                  size={"sm"}
                  variant={"filled"}
                  border={"1px solid #B0BEC5"}
                  isInvalid={errors.cidade ? true : false}
                  {...register("cidade", {
                    required: "Campo obrigatório!",
                  })}
                />
                {errors.cidade && (
                  <span className="label">{errors.cidade.message}</span>
                )}
              </FormControl>
              <FormControl className="inputControl">
                <Text color="#3F3D56" fontSize={15} fontWeight={500}>
                  UF
                </Text>
                <Input
                  as={InputMask}
                  mask="aa"
                  size={"sm"}
                  variant={"filled"}
                  border={"1px solid #B0BEC5"}
                  isInvalid={errors.uf ? true : false}
                  {...register("uf", {
                    required: "Campo obrigatório!",
                  })}
                />
                {errors.uf && (
                  <span className="label">{errors.uf.message}</span>
                )}
              </FormControl>
            </InputGroup>

            <InputGroup className="iputGrup">
              <FormControl className="inputControl" mr={7}>
                <Text color="#3F3D56" fontSize={15} fontWeight={500}>
                  WhatsApp
                </Text>
                <Input
                  as={InputMask}
                  mask="(99)99999-9999"
                  className="input-mb"
                  type="tel"
                  size={"sm"}
                  variant={"filled"}
                  border={"1px solid #B0BEC5"}
                  isInvalid={errors.whatsapp ? true : false}
                  {...register("whatsapp", {
                    required: "Campo obrigatório!",
                  })}
                />
                {errors.whatsapp && (
                  <span className="label">{errors.whatsapp.message}</span>
                )}
              </FormControl>
              <FormControl className="inputControl">
                <Text color="#3F3D56" fontSize={15} fontWeight={500}>
                  Instagram
                </Text>
                <Input
                  type="text"
                  size={"sm"}
                  variant={"filled"}
                  border={"1px solid #B0BEC5"}
                  {...register("instagram")}
                />
              </FormControl>
            </InputGroup>

            <FormControl className="inputControl" mb={3}>
              <Text color="#3F3D56" fontSize={15} fontWeight={500}>
                Email
              </Text>
              <Input
                type="email"
                size={"sm"}
                variant={"filled"}
                border={"1px solid #B0BEC5"}
                isInvalid={errors.email ? true : false}
                {...register("email", {
                  required: "Campo obrigatório!",
                })}
              />
              {errors.email && (
                <span className="label">{errors.email.message}</span>
              )}
            </FormControl>

            <InputGroup className="iputGrup">
              <FormControl className="inputControl" mr={7}>
                <Text color="#3F3D56" fontSize={15} fontWeight={500}>
                  Senha
                </Text>
                <Input
                  className="input-mb"
                  type="password"
                  size={"sm"}
                  variant={"filled"}
                  border={"1px solid #B0BEC5"}
                  value={password}
                  required
                  isInvalid={errors.senha ? true : false}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </FormControl>
              <FormControl className="inputControl">
                <Text color="#3F3D56" fontSize={15} fontWeight={500}>
                  Confirmar a senha
                </Text>
                <Input
                  type="password"
                  size={"sm"}
                  variant={"filled"}
                  border={"1px solid #B0BEC5"}
                  value={confirmPassword}
                  required
                  isInvalid={errors.senha ? true : false}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </FormControl>
            </InputGroup>
            <InputGroup gap={1}>
              <Checkbox
                value={"aceito"}
                pt={"1rem"}
                {...register("termo", { required: "Campo obrigatório!" })}
              >
                ATESTO QUE LI E CONCORDO COM TODOS OS PRESENTES
              </Checkbox>
              <span className="btn-termo" onClick={onOpen}>
                TERMOS E CONDIÇÕES
              </span>
            </InputGroup>
            {errors.termo && (
              <Text className="label">{errors.termo.message}</Text>
            )}

            <InputGroup className="btn" display={"contents"}>
              <Link to={"/"} className="btn-cancelar">
                Cancelar
              </Link>
              <Button
                type="submit"
                w={40}
                h={8}
                border={"1px solid #044549"}
                color={"#044549"}
                fontWeight={"medium"}
                backgroundColor={"white"}
              >
                Salvar
              </Button>
            </InputGroup>

            <Modal
              onClose={onClose}
              finalFocusRef={btnRef}
              isOpen={isOpen}
              scrollBehavior={"inside"}
            >
              <ModalOverlay />
              <ModalContent>
                <ModalHeader>
                  TERMO DE AUTORIZAÇÃO E CONSENTIMENTO PARA TRATAMENTO DE DADOS
                  PESSOAIS
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  <Text>
                    Em conformidade com o previsto na Lei n.º 13.709, de 2018,
                    Lei Geral de Proteção de Dados Pessoais (LGPD), eu,
                    doravante identificado como TITULAR DE DADOS, ou
                    simplesmente, TITULAR, autorizo a empresa CENTRO
                    UNIVERSITÁRIO DR. LEÃO SAMPAIO – UNILEAO, inscrita no CNPJ
                    nº 02.391.959/0001-20, doravante denominada CONTROLADORA, ao
                    tratamento dos meus dados pessoais, podendo tomar decisões
                    quanto ao uso e compartilhamento de dados, especialmente
                    para a finalidade de possibilitar o cadastro do TITULAR na
                    plataforma Web de gerenciamento de adoções de animais da
                    CONTROLADORA, denominado de “NINA”.{" "}
                  </Text>
                  <Text p={"1rem 0"} fontWeight={"bold"}>
                    1. DADOS{" "}
                  </Text>
                  <Text>
                    Pelo presente termo, de forma livre, informada e inequívoca,
                    Autorizo o tratamento de meus dados pessoais e a tomada de
                    decisões pela CONTROLADORA acerca dos seguintes dados:
                  </Text>
                  <Text pt={"1rem"}>
                    1) NOME COMPLETO; 2) NÚMERO DE RG OU CNH; 3) NÚMERO CPF; 4)
                    ENDEREÇO DE E-MAIL; 5) NÚMERO TELEFONE E WHATSAPP; 6)
                    ENDEREÇO; 7) NOME DE USUÁRIO E SENHA
                  </Text>
                  <Text p={"1rem 0"} fontWeight={"bold"}>
                    2. FINALIDADE
                  </Text>
                  <Text>
                    Autorizo, ainda, expressamente, que a CONTROLADORA utilize
                    os dados pessoais listados no presente termo para as
                    seguintes finalidades:
                  </Text>
                  <Text p={"1rem 0"}>
                    a) Possibilitar o mantimento de cadastro na plataforma Web
                    NINA, de forma a tornar possível a adoção responsável de
                    animais abrigados no Hospital Veterinário da CONTROLADORA;
                  </Text>
                  <Text>
                    b) Verifique o atendimento, pelo TITULAR, das condições
                    necessárias à adoção responsável;{" "}
                  </Text>
                  <Text p={"1rem 0"}>
                    c) Permitir que a CONTROLADORA identifique e entre em
                    contato com o TITULAR, por intermédio de seus prepostos e/ou
                    representantes legais;
                  </Text>
                  <Text>
                    d) Para cumprimento, pela CONTROLADORA, de obrigações
                    impostas por órgãos de fiscalização;
                  </Text>
                  <Text p={"1rem 0"}>
                    e) Quando necessário, para atender aos interesses legítimos
                    da controladora ou de terceiros, exceto no caso de
                    prevalecer em direitos e liberdades fundamentais do titular
                    que exijam a proteção dos dados pessoais;
                  </Text>
                  <Text>
                    f) Para fins de marketing (leads) e/ou prospecção, de forma
                    a informar o TITULAR de outros produtos e serviços ofertados
                    pela CONTROLADORA; assim como para fins de participação em
                    pesquisas realizadas pela CONTROLADORA, com vistas à
                    melhoria na prestação dos seus serviços.
                  </Text>
                  <Text p={"1rem 0"} fontWeight={"bold"}>
                    3. COMPARTILHAMENTO DE DADOS
                  </Text>
                  <Text>
                    A Controladora fica autorizada a compartilhar os dados
                    pessoais do Titular com outros agentes de tratamento de
                    dados, caso seja necessário para as finalidades listadas
                    neste instrumento, desde que, sejam respeitados os
                    princípios da boa-fé, finalidade, adequação, necessidade,
                    livre acesso, qualidade dos dados, transparência, segurança,
                    prevenção, não discriminação e responsabilização e prestação
                    de contas.
                  </Text>
                  <Text p={"1rem 0"} fontWeight={"bold"}>
                    4. DOS DIREITOS DO TITULAR DE DADOS{" "}
                  </Text>
                  <Text>
                    O Titular tem direito a obter do Controlador, em relação aos
                    dados por ele tratados, a qualquer momento e mediante
                    requisição: I - confirmação da existência de tratamento; II
                    - acesso aos dados; III – correção de dados incompletos,
                    inexatos ou desatualizados; IV - anonimização, bloqueio ou
                    eliminação de dados desnecessários, excessivos ou tratados
                    em desconformidade com o disposto na Lei nº 13.709; V -
                    portabilidade dos dados a outro fornecedor de serviço ou
                    produto, mediante requisição expressa, de acordo com a
                    regulamentação da autoridade nacional, observados os
                    segredos comercial e industrial; VI - eliminação dos dados
                    pessoais tratados com o consentimento do titular, exceto nas
                    hipóteses previstas no art. 16 da Lei nº 13.709; VII -
                    informação das entidades públicas e privadas com as quais o
                    controlador realizou uso compartilhado de dados; VIII -
                    informação sobre a possibilidade de não fornecer
                    consentimento e sobre as consequências da negativa; IX -
                    revogação do consentimento, nos termos do § 5º do art. 8º da
                    Lei nº 13.709/2018.
                  </Text>
                  <Text p={"1rem 0"} fontWeight={"bold"}>
                    5. DAS OBRIGAÇÕES DA CONTROLADORA
                  </Text>
                  <Text>
                    A CONTROLADORA se responsabiliza por manter medidas de
                    segurança técnicas e administrativas suficientes a proteger
                    os dados pessoais do TITULAR, comunicando-o caso aconteça
                    qualquer incidente de segurança que possa acarretar risco ou
                    dano relevante, conforme disposto no artigo 48 da Lei
                    13.709/2018.
                  </Text>
                  <Text p={"1rem 0"} fontWeight={"bold"}>
                    6. PERÍODO DE DURAÇÃO E REVOGAÇÃO CONSENTIMENTO
                  </Text>
                  <Text>
                    A CONTROLADORA poderá manter e tratar dos dados pessoais do
                    TITULAR durante todo o período em que tais informações forem
                    pertinentes ao alcance das finalidades listadas no presente
                    Termo, podendo o TITULAR revogar seu consentimento com esse
                    a qualquer tempo, por carta eletrônica ou escrita, conforme
                    o parágrafo 5º do artigo 8º combinado com o inciso VI do
                    caput do artigo 18 e com o artigo 16 da Lei 13.709/2018.
                  </Text>
                  <Text textAlign={"right"} p={"1rem 0"}>
                    Juazeiro do Norte-CE, {dayjs().format("DD/MM/YYYY")}.
                  </Text>
                </ModalBody>
                <ModalFooter>
                  <Button
                    bg={"#f90303"}
                    color={"#ffffff"}
                    _hover={{ backgroundColor: "#c03333" }}
                    onClick={onClose}
                  >
                    fechar
                  </Button>
                </ModalFooter>
              </ModalContent>
            </Modal>
          </form>
        </div>
      </Container>
      {tutorId != "" ? (
        <>
          <ModalInforComp
            tutor_id={tutorId}
            cadastroUser={"cadastroUser"}
            onClose={handleCloseModal}
            isOpen={isModal}
          />
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export { CadastroUser };
